import * as RankingService from '@/services/apis/ranking'
const state = {

}

const actions = {
  async getRankingRole({ }, params) {
        try {
          const res = await RankingService.getRankingRole(params)
          if (res.status === 201 || res.status === 200) {
            return res.data;
          } else {
            throw Error(JSON.stringify({ message: res.data.message }));
          }

        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },

    async getUserRanking({ }, params) {
        try {
          const res = await RankingService.getUserRanking(params)
          if (res.status === 201 || res.status === 200) {
            return res.data;
          } else {
            throw Error(JSON.stringify({ message: res.data.message }));
          }

        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },

      async getUserTop50({ }, params) {
        try {
          const res = await RankingService.getUserTop50(params)
          if (res.status === 201 || res.status === 200) {
            return res.data;
          } else {
            throw Error(JSON.stringify({ message: res.data.message }));
          }

        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
}

export default {
    state,
    actions,
}
